import { OG_IMAGES } from './ogManifest';

/** Per-page Open Graph image generated by scripts/og-images.mjs, keyed by route path. */
export function ogImageFor(canonicalUrl?: string): string | undefined {
  if (!canonicalUrl) return undefined;
  let path: string;
  try {
    path = new URL(canonicalUrl).pathname.replace(/\/$/, '') || '/';
  } catch {
    return undefined;
  }
  const file = OG_IMAGES[path];
  return file ? `https://beatview.ai/og/${file}` : undefined;
}
